import { useEffect, useRef, useState } from "react";
import { api } from "../lib/api";
import { mountGoogleButton, providersConfigured } from "../lib/providers";

export default function SignIn({ onSignedIn }: { onSignedIn: () => void }) {
  const googleRef = useRef<HTMLDivElement>(null);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const el = googleRef.current;
    if (!el) return;
    let cancelled = false;
    mountGoogleButton(
      el,
      async (credential) => {
        try {
          await api.loginGoogle(credential);
          onSignedIn();
        } catch (e) {
          setError((e as Error).message);
        }
      },
      () => cancelled,
    ).catch((e) => !cancelled && setError(e.message));
    return () => {
      cancelled = true;
      el.replaceChildren();
    };
  }, [onSignedIn]);

  return (
    <div className="signin">
      <div className="signin-inner">
        <div className="signin-diamond">◆</div>
        <h1 className="signin-title">Walk to Mordor</h1>
        <p className="signin-pitch">Walk the 1,779 miles from the Shire to Mount Doom. Then walk home.</p>
        <div ref={googleRef} className="google-slot" />
        {!providersConfigured.google && <p className="error">Google sign-in is not configured on this deployment.</p>}
        {error && <p className="error">{error}</p>}
        <p className="footnote">A fan-made fitness journey. Not affiliated with the Tolkien Estate or any studio.</p>
      </div>
    </div>
  );
}
